export const DEFAULT_USER_LANGUAGE = 'en-US';